import Head from 'next/head'
import { getRequestJSON } from '../../../api/index/location-api';
import Script from 'next/script'
import { PropertyAgent } from '../../../components/index/service-category/property-agent/PropertyAgent';
import { getArticleDateTime } from '../../../utils/article-date-time';
import { getDistanceMetrics } from '../../../utils/distance-matrix';
import { downloadServiceProviders } from '../../../api/service-provider/sp-list';

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
  const countryCd = "sg"

  //const { modifiedDate, month, year } = getArticleDateTime();

  const countryName = "Singapore"
  
  const allRequestCategorySettings = await getRequestJSON(countryName)

  const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Housing")

  const distanceUnit = getDistanceMetrics(countryName)
    
  const lat = 1.3521
  const lng = 103.8198

  const spList =  await downloadServiceProviders("Housing", 0, 10, countryName, lat, lng, 50, distanceUnit, false)

  return {
      props: {
        requestCategorySettings,
        countryName,
        countryCd,
        // modifiedDate,
        // month,
        // year,
        spList
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
// export async function getStaticPaths() {

//     // Get the paths we want to pre-render based on posts
//     const paths = countryList.map((country) => ({
//       params: { countryCd: country.country_cd },
//     }))

//     // We'll pre-render only these paths at build time.
//     // { fallback: blocking } will server-render pages
//     // on-demand if the path doesn't exist.
//     return { paths, fallback: 'blocking' }
// }

export default function Home(props) {
  const requestCategorySettings = props.requestCategorySettings
  const countryName = props.countryName
  const countryCd = props.countryCd
  // const modifiedDate = props.modifiedDate
  // const month = props.month
  // const year = props.year
  const spList = props.spList

  return (
    <>
      <Head>
        <title>{`Condo or HDB Rent ${countryName} | Property Agent`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description"
            content={`Buy a property or rent a house easily with the best property agents in ${countryName}`}/>
        <meta name="keywords"
            content="House rental, buy a house, property Agents"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification"
            content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/sg/property-agent`} />
        <meta property="og:type"   content="website" />
        <meta property="og:title"  content={`Condo or HDB Rent ${countryName} | Property Agent`}/>
        <meta property="og:description" content={`Buy a property or rent a house easily with the best property agents in ${countryName}`}/>
        <meta property="og:site_name" content={`Property Agents ${countryName} | StringsSG"`} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Property-Agent-Singapore.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/property-agent`}/>
        <meta name="twitter:title"  content={`Condo or HDB Rent ${countryName} | Property Agent`}/> 
        <meta name="twitter:description" content={`Buy a property or rent a house easily with the best property agents in ${countryName}`}/> 
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Property-Agent-Singapore.jpg" /><link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/property-agent" />
      </Head> 
        <div className="overflow-hidden">
            <PropertyAgent requestCategorySettings={requestCategorySettings} countryName={countryName} spList={spList} h1Tag="Rental in"/>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}